import { AxiosResponse } from "axios";
import api from "../api/base-api";
import analyticsApi from "../api/analytics-api";
import analyticsPgApi from "../api/analytics-api-pg";

const fetchAppInstallsForDeveloperApi = (token: string): Promise<AxiosResponse> => {
    return api.get(`analytics/developer/app-installs`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchAppsAndVersionForOemApi = async (token: string): Promise<AxiosResponse> => {
    return api.get(`/applications/oem/apps-and-versions`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchCountriesForOemAppApi = (token: string, appId: string): Promise<AxiosResponse> => {
    return api.get(`/applications/oem/locations?oem_app_id=${appId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchModelsForOemAppApi = (token: string, appId: string): Promise<AxiosResponse> => {
    return api.get(`/applications/oem/models?oem_app_id=${appId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchStartDateForSelectedAppApi = (token: string, appId: string): Promise<AxiosResponse> => {
    return api.get(`/applications/oem/start-time?oem_app_id=${appId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchCountryDistributionApi = (
    token: string,
    applicationId: string
): Promise<AxiosResponse> => {
    return api.post(
        `applications/oem/country-distribution`,
        {
            applicationId,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

interface SelectedVersion {
    id: string;
    name: string;
}

interface SelectedCountry {
    id: string;
    name: string;
}

const fetchChartDataApi = (
    appId: string,
    versions: Array<SelectedVersion>,
    countries: Array<SelectedCountry>,
    models: Array<SelectedCountry>,
    dateRange: Array<Date>,
    token: string,
    view: string
): Promise<AxiosResponse> => {
    const GET_CHART_FROM_POSTGRES = true;
    const api = GET_CHART_FROM_POSTGRES ? analyticsPgApi : analyticsApi;
    return api.post(
        `/oem/chart`,
        {
            appId,
            versions: versions ? versions.map((version) => version.id) : null,
            countries: countries ? countries.map((country) => country.name) : null,
            models: models ? models.map((model) => model.name) : null,
            dateRange: dateRange.map(
                (d) => `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
            ),
            token,
            view: !view || view === "" ? null : view,
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

const fetchVersionForDeveloperAppApi = (token: string, appId: string): Promise<AxiosResponse> => {
    return api.get(`applications/developer/${appId}/versionings`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchOemAppStoreEngagementApi = (token: string): Promise<AxiosResponse> => {
    return api.get(`/applications/oem/appstore-engagement`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchTotalUsersApi = (token: string): Promise<AxiosResponse> => {
    return api.get(`analytics/oem/total-users`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchUserGrowthApi = (token: string, since: string): Promise<AxiosResponse> => {
    return api.get(`analytics/oem/user-growth?since=${since}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const fetchAppsPerUserApi = (token: string): Promise<AxiosResponse> => {
    return api.get(`analytics/oem/apps-per-user`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export {
    fetchAppsAndVersionForOemApi,
    fetchCountriesForOemAppApi,
    fetchAppInstallsForDeveloperApi,
    fetchStartDateForSelectedAppApi,
    fetchCountryDistributionApi,
    fetchChartDataApi,
    fetchVersionForDeveloperAppApi,
    fetchModelsForOemAppApi,
    fetchOemAppStoreEngagementApi,
    fetchTotalUsersApi,
    fetchUserGrowthApi,
    fetchAppsPerUserApi,
};
